module.exports = __webpack_public_path__ + "img/tarj1-4.840ef9d2.svg";